import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { register } from "../../helpers/api";

function Register(){

    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);

    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState(false);

    const [name, setName] = useState('');
    const [nameError, setNameError] = useState(false);


    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const submitForm = async () => {
        setLoading(true);

        if(email === ''){
             setEmailError(true)
            setLoading(false);

            return;
        }

        if(name === ''){
            setNameError(true)

            setLoading(false);
            return;
        }   

        if(password === ''){
            setPasswordError(true)

            setLoading(false);
            return;
        }

        let response = await register({email,password,name});

        if(response.status){
            localStorage.setItem('authToken',response.data.access_token);
            navigate("/dashboard/home");
        }else{
            alert(response.message);

        }
        console.log("Register response is -> ",response);

        setLoading(false);

        

    }

    return (
        <div className="page-wrapper">
        <div className="page-content--bge5">
            <div className="container">
                <div className="login-wrap">
                    <div className="login-content">
                        <div className="login-logo">
                            <div >
                                <img src="images/icon/logo.png" alt="CoolAdmin"/>
                            </div>
                        </div>
                        <div className="login-form">
                            <form>
                                <div className="form-group">
                                    <label>Name</label>
                                    <input onChange={(e)=>{ setName(e.target.value)}} className="au-input au-input--full" type="text" name="full_name" placeholder="Full Name"/>
                                   { nameError && <p style={{color:"red"}}>This field is required.</p>}
                                </div>
                                <div className="form-group">
                                    <label>Email Address</label>
                                    <input onChange={(e)=>{ setEmail(e.target.value)}} className="au-input au-input--full" type="email" name="email" placeholder="Email"/>
                                   { emailError && <p style={{color:"red"}}>This field is required.</p>}

                                </div>
                                <div className="form-group">
                                    <label>Password</label>
                                    <input onChange={(e)=>{ setPassword(e.target.value)}} className="au-input au-input--full" type="password" name="password" placeholder="Password"/>
                                   { passwordError && <p style={{color:"red"}}>This field is required.</p>}

                                </div>
                             
                                <button className="au-btn au-btn--block au-btn--green m-b-20" type="button" onClick={submitForm}> {loading? "Loading... Please Wait" :"Sign Up"}</button>
                                
                            </form>
                            <div className="register-link">
                                <p>
                                    Don't you have account?
                                    <Link to="/login">Sign In Here</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    )
}

export default Register;